/**
 * RoleGate — conditionally renders children based on the current
 * user's permission set or platform_role.
 *
 * Phase A. Wraps any UI surface that should be hidden when the user
 * lacks the relevant permission. Frontend-only — the server enforces
 * the same gate via `require_permission` in `/app/backend/auth/deps.py`.
 *
 * Usage:
 *
 *   <RoleGate me={me} permission="admin.legal_ip.read">
 *     <LegalIpPanel />
 *   </RoleGate>
 *
 *   <RoleGate me={me} role="founder">...</RoleGate>
 *
 *   <RoleGate me={me} uiFlag="show_rate_card_master">...</RoleGate>
 */
import React from "react";

export const RoleGate = ({
  me,
  permission,
  role,
  uiFlag,
  fallback = null,
  children,
}) => {
  if (!me) return fallback;

  if (uiFlag) {
    const flags = me.ui_flags || {};
    if (!flags[uiFlag]) return fallback;
  }

  if (permission) {
    const perms = Array.isArray(me.permissions) ? me.permissions : [];
    if (!perms.includes(permission)) return fallback;
  }

  if (role) {
    const wanted = Array.isArray(role) ? role : [role];
    if (!wanted.includes(me.platform_role)) return fallback;
  }

  return children;
};

export default RoleGate;
